module.exports = __webpack_public_path__ + "img/custom_img3.5b00d6fc.png";